import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class ReporteService {

  url = environment.baseUrl+ '/api/Reporte';

  constructor(private http: HttpClient) {}

  getIngresosHoy(page: number, numReg: number,searchString:string): Observable<any> {
    const body = { page, numReg,searchString};
    console.log('el cuerpo es: ', body)
    return this.http.post<any>(this.url + '/GetIngresosHoy', body, httpOption);
  }

  getIngresosFechas(page: number, numReg: number,searchString:string, fechaInicio:string, fechaFin:string, disciplinaId?:string ): Observable<any> {
    const body = { page, numReg,searchString, fechaInicio, fechaFin, disciplinaId};
    console.log('el cuerpo es: ', body)
    return this.http.post<any>(this.url + '/GetIngresosFechas', body, httpOption);
  }
  getIngresosFechasAdmin(page: number, numReg: number,searchString:string, fechaInicio:string, fechaFin:string, disciplinaId?:string, empresaId?:string ): Observable<any> {
    const body = { page, numReg,searchString, fechaInicio, fechaFin, disciplinaId, empresaId};
    console.log('el cuerpo es: ', body)
    return this.http.post<any>(this.url + '/GetIngresosFechasAdmin', body, httpOption);
  }

  getIngresosCuadro(fechaInicio:string, fechaFin:string, disciplinaId?:string, empresaId?:string ): Observable<any> {
    const body = {fechaInicio, fechaFin, disciplinaId, empresaId};
    console.log('el cuerpo es: ', body)
    return this.http.post<any>(this.url + '/GetIngresosCuadro', body, httpOption);
  }

  getIngresosExtraordinariosFechas(page: number, numReg: number,searchString:string, fechaInicio:string, fechaFin:string, disciplinaId?:string ): Observable<any> {
    const body = { page, numReg,searchString, fechaInicio, fechaFin, disciplinaId};
    console.log('el cuerpo es: ', body)
    return this.http.post<any>(this.url + '/GetIngresosExtraordinariosFechas', body, httpOption);
  }

  getIngresosExtraordinariosAdminFechas(page: number, numReg: number,searchString:string, fechaInicio:string, fechaFin:string,empresaId:string, disciplinaId?:string ): Observable<any> {
    const body = { page, numReg,searchString, fechaInicio, fechaFin,empresaId, disciplinaId};
    console.log('el cuerpo es: ', body)
    return this.http.post<any>(this.url + '/GetIngresosExtraordinariosAdminFechas', body, httpOption);
  }

  getIngresosUnicosFechas(fechaInicio:string, fechaFin:string ): Observable<any> {
    const body = { fechaInicio, fechaFin,};
    console.log('el cuerpo es: ', body)
    return this.http.post<any>(this.url + '/GetIngresosUnicosFechas', body, httpOption);
  }

  getIngresosUsuario(page: number, numReg: number,searchString:string): Observable<any> {
    const body = { page, numReg,searchString};// este searchString es el id del usuario
    return this.http.post<any>(this.url + '/GetIngresosUsuario', body, httpOption);
  }

  getDeportistasPorExpirar(page: number, numReg: number,searchString:string): Observable<any> {
    const body = { page, numReg,searchString};// este searchString es el id del usuario
    return this.http.post<any>(this.url + '/GetDeportistasPorExpirar', body, httpOption);
  }

  getReporteIngresosPorFecha(obj:any): Observable<any> {
   // const body = { fecha};
    return this.http.post<Blob>(this.url+'/GetReporteIngresosPorFecha',obj, {responseType: 'blob' as 'json'});
  }
  
}
